import React, {useContext} from 'react'
import { StateContext } from '../../context/GlobalState.jsx'
import {Link} from 'react-router-dom'
import {GetText} from "../../context/text.js";

function FavoriteItem({item}) {
    // consuming contexts
    let {removeFromFavorite, courseUSD, lang} = useContext(StateContext)

    let text = GetText();

    // render JSX
    return (
        <div className="wishlist-detail padBottom product-card">
            <div className="product-info-col">
                <div className="product-detail-image">

                    { item.PHOTO == "" ? <img src="https://zapauto.com.ua/backend/public/images/logo-zapauto.png" alt="product" /> : <img src={item.PHOTO.replace("../", "https://zapauto.com.ua/")} alt="product" /> }

                </div>


            </div>
            <div className="product-qty-col">
                <div className="product-detail-info">
                    <h5> <b>{item.MANUFACTURER}</b> | <b>{item.PART_NUMBER}</b></h5>


                    { lang === "ua" ? <h5><b>{item.NAME_UA}</b></h5> : ""}
                    { lang === "ru" ? <h5><b>{item.NAME_RU}</b></h5> : ""}
                    { lang === "en" ? <h5><b>{item.NAME_EN}</b></h5> : ""}


                    {/* product price */}
                    { lang === "ua" ? <h6>{item.PRICE_USD * courseUSD} грн </h6> : ""}
                    { lang === "ru" ? <h6>{item.PRICE_USD * courseUSD} грн </h6> : ""}
                    { lang === "en" ? <h6>{item.PRICE_USD * courseUSD} UAH </h6> : ""}


                </div>
                <Link to={`/product/${item.PART_NUMBER}`}>
                    <button className="view-detail-btn">
                        {text.FavoriteItem.detailButton}
                    </button>
                </Link> 
            </div>
            <div className="product-counter-col">
                <button onClick={() => removeFromFavorite(item.ID)}>
                    <i className="ri-dislike-line"></i> 
                    <span className="undofavorite-text">  {text.FavoriteItem.removeButton}</span>
                </button>

            </div>
        </div>
    )
}

export default FavoriteItem
